import {
  Archive,
  Bell,
  BellRing,
  Boxes,
  ClipboardCheck,
  ClipboardList,
  FileBarChart,
  History,
  Laptop,
  LayoutDashboard,
  ListPlus,
  type LucideIcon,
  Mail,
  Package,
  PenLine,
  Settings2,
  ShieldCheck,
  Tags,
  Trash2,
  Workflow,
  Wrench,
} from "lucide-react";

export interface NavItem {
  to: string;
  label: string;
  icon: LucideIcon;
  permission?: string;
  badge?: string;
}

export interface NavGroup {
  label: string;
  items: NavItem[];
}

export const NAV_GROUPS: NavGroup[] = [
  {
    label: "概览",
    items: [{ to: "/", label: "工作台", icon: LayoutDashboard }],
  },
  {
    label: "资产与物料",
    items: [
      { to: "/assets", label: "资产台账", icon: Laptop, permission: "menu:assets" },
      { to: "/materials", label: "物料目录", icon: Package, permission: "menu:materials" },
      {
        to: "/accessories",
        label: "低值易耗",
        icon: Boxes,
        permission: "menu:accessories",
      },
      { to: "/licenses", label: "软件许可", icon: Tags, permission: "menu:licenses" },
      {
        to: "/label-tasks",
        label: "标签任务",
        icon: Archive,
        permission: "menu:label_tasks",
      },
    ],
  },
  {
    label: "业务办理",
    items: [
      {
        to: "/approvals",
        label: "待办审批",
        icon: ClipboardCheck,
        permission: "menu:approvals",
      },
      {
        to: "/requests",
        label: "业务办理",
        icon: ClipboardList,
        permission: "menu:requests",
      },
      {
        to: "/maintenance",
        label: "维修维保",
        icon: Wrench,
        permission: "menu:maintenance",
      },
      {
        to: "/disposals",
        label: "处置审批",
        icon: Trash2,
        permission: "asset:manage",
      },
    ],
  },
  {
    label: "运营",
    items: [
      {
        to: "/inventory",
        label: "库存视图",
        icon: Boxes,
        permission: "menu:inventory",
      },
      {
        to: "/consumables",
        label: "耗材库存",
        icon: Package,
        permission: "menu:inventory",
      },
      {
        to: "/stocktakes",
        label: "库存盘点",
        icon: ClipboardList,
        permission: "inventory:manage",
      },
      { to: "/reports", label: "统计报表", icon: FileBarChart, permission: "menu:reports" },
      { to: "/reminders", label: "提醒中心", icon: Bell, permission: "menu:reminders" },
      { to: "/audit", label: "审计日志", icon: History, permission: "menu:audit" },
      {
        to: "/attachments",
        label: "附件管理",
        icon: Archive,
        permission: "menu:attachments",
      },
    ],
  },
  {
    label: "系统设置",
    items: [
      {
        to: "/settings/organization",
        label: "组织与人员",
        icon: Settings2,
        permission: "menu:admin_personnel",
      },
      {
        to: "/settings/access",
        label: "用户与角色",
        icon: ShieldCheck,
        permission: "menu:admin_access",
      },
      {
        to: "/settings/master-data",
        label: "主数据",
        icon: Boxes,
        permission: "menu:admin_master_data",
      },
      {
        to: "/settings/code-rules",
        label: "编号规则",
        icon: Tags,
        permission: "menu:admin_code_rules",
      },
      {
        to: "/settings/label",
        label: "标签设置",
        icon: Tags,
        permission: "menu:admin_label_settings",
      },
      {
        to: "/settings/security",
        label: "安全与登录",
        icon: ShieldCheck,
        permission: "menu:admin_source_whitelist",
      },
      {
        to: "/settings/esign",
        label: "电子签章",
        icon: PenLine,
        permission: "admin:access:manage",
      },
      {
        to: "/settings/notifications",
        label: "通知渠道",
        icon: BellRing,
        permission: "admin:access:manage",
      },
      {
        to: "/settings/fields",
        label: "自定义字段",
        icon: ListPlus,
        permission: "admin:master-data:manage",
      },
      {
        to: "/settings/approval",
        label: "审批矩阵",
        icon: Workflow,
        permission: "admin:access:manage",
      },
      {
        to: "/settings/email",
        label: "邮件通知",
        icon: Mail,
        permission: "admin:system:read",
      },
      {
        to: "/settings/special",
        label: "特殊情况",
        icon: Wrench,
        permission: "menu:admin_special_actions",
      },
    ],
  },
];

export const PAGE_TITLES: Record<string, string> = {
  "/": "工作台",
  "/assets": "资产台账",
  "/materials": "物料目录",
  "/accessories": "低值易耗",
  "/licenses": "软件许可",
  "/label-tasks": "标签任务",
  "/approvals": "待办审批",
  "/requests": "业务办理",
  "/maintenance": "维修维保",
  "/disposals": "处置审批",
  "/inventory": "库存视图",
  "/consumables": "耗材库存",
  "/stocktakes": "库存盘点",
  "/reports": "统计报表",
  "/reminders": "提醒中心",
  "/audit": "审计日志",
  "/attachments": "附件管理",
  "/settings/organization": "组织与人员",
  "/settings/access": "用户与角色",
  "/settings/master-data": "主数据",
  "/settings/code-rules": "编号规则",
  "/settings/label": "标签设置",
  "/settings/security": "安全与登录",
  "/settings/email": "邮件通知",
  "/settings/approval": "审批矩阵",
  "/settings/fields": "自定义字段",
  "/settings/notifications": "通知渠道",
  "/settings/esign": "电子签章",
  "/settings/special": "特殊情况",
};
